import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DashboardTopSearch from "../../../components/DashboardTopSearch/DashboardTopSearch";
import TabFilterCourse from "../../../components/TabFilterCourse/TabFilterCourse";
import StudentEnrolledCourse from "../../../components/StudentEnrolledCourse/StudentEnrolledCourse";
import {
  getAllstudentCourseAPI,
  studentAllCourseAPI,
  studentCompletedCourseAPI,
} from "../../../redux/features/studentDetailSlice";
import {
  studentAllCourseCategoriesApi,
  studentEnrolledCourseApi,
  studentFavoriteCourseApi,
} from "../../../redux/features/studentDetailSlice";
import StudentAllCourse from "../../../components/StudentAllCourse/StudentAllCourse";
import Notification from "../../../components/Notification/Notification";

// Enrolled course types
const ENROLL_COURSE_CATEGORIES = [
  "All Courses",
  "Enrolled Courses",
  "Favorites Courses",
  "Completed Courses",
];

const StudentCourses = () => {
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const [courseCategories, setCourseCategories] = useState(["All Courses"]);
  const [allCourses, setAllCourses] = useState([]);
  const [allCoursesFilterByCategory, setAllCoursesFilterByCategory] = useState(
    []
  );
  const [favoritesCourses, setFavoritesCourses] = useState([]);
  const [enrolledCourses, setEnrolledCourses] = useState([]);
  const [studentCompletedCourses, setStudentCompletedCourses] = useState([]);
  const [getAllStudentCourses, setGetAllStudentCourses] = useState([]);
  const [activeCourse, setActiveCourse] = useState("All Courses");
  const [activeEnrollCourse, setActiveEnrollCourse] =
    useState("Enrolled Courses");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const UpdateDatafetch = async () => {
    try {
      const [
        studentAllCourseResult,
        studentFavoritesResult,
        studentEnrolledResult,
        courseCategoriesResult,
        studentCompletedCourseResult,
        getAllstudentCourseResult,
      ] = await Promise.all([
        dispatch(studentAllCourseAPI({ token: auth.token })).unwrap(),
        dispatch(studentFavoriteCourseApi({ token: auth.token })).unwrap(),
        dispatch(studentEnrolledCourseApi({ token: auth.token })).unwrap(),
        dispatch(studentAllCourseCategoriesApi({ token: auth.token })).unwrap(),
        dispatch(studentCompletedCourseAPI({ token: auth.token })).unwrap(),
        dispatch(getAllstudentCourseAPI({ token: auth.token })).unwrap(),
      ]);

      if (studentAllCourseResult.success) {
        let courseWithoutEnrolled = [];
        courseWithoutEnrolled = studentAllCourseResult.data.filter(
          (item) => !item.enrolled
        );

        setAllCourses(courseWithoutEnrolled);
      }
      if (studentFavoritesResult.success)
        setFavoritesCourses(studentFavoritesResult.data);
      if (studentEnrolledResult.success)
        setEnrolledCourses(studentEnrolledResult.data);

      if (studentCompletedCourseResult.success)
        setStudentCompletedCourses(studentCompletedCourseResult.data);

      if (getAllstudentCourseResult.success)
        setGetAllStudentCourses(getAllstudentCourseResult.data);

      if (courseCategoriesResult.success) {
        const dynamicCategories = courseCategoriesResult.data.map(
          (cat) => cat.name
        );
        setCourseCategories(["All Courses", ...dynamicCategories]);
      } else {
        console.warn("Categories fetch unsuccessful");
      }
    } catch (error) {
      setError("Failed to fetch courses. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const fetchCourses = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const [
          studentAllCourseResult,
          studentFavoritesResult,
          studentEnrolledResult,
          courseCategoriesResult,
          studentCompletedCourseResult,
          getAllstudentCourseResult,
        ] = await Promise.all([
          dispatch(studentAllCourseAPI({ token: auth.token })).unwrap(),
          dispatch(studentFavoriteCourseApi({ token: auth.token })).unwrap(),
          dispatch(studentEnrolledCourseApi({ token: auth.token })).unwrap(),
          dispatch(
            studentAllCourseCategoriesApi({ token: auth.token })
          ).unwrap(),
          dispatch(studentCompletedCourseAPI({ token: auth.token })).unwrap(),
          dispatch(getAllstudentCourseAPI({ token: auth.token })).unwrap(),
        ]);

        if (studentAllCourseResult.success) {
          let courseWithoutEnrolled = [];
          courseWithoutEnrolled = studentAllCourseResult.data.filter(
            (item) => !item.enrolled
          );

          setAllCourses(courseWithoutEnrolled);
        }
        if (studentFavoritesResult.success)
          setFavoritesCourses(studentFavoritesResult.data);
        if (studentEnrolledResult.success)
          setEnrolledCourses(studentEnrolledResult.data);
        if (studentCompletedCourseResult.success)
          setStudentCompletedCourses(studentCompletedCourseResult.data);

        if (getAllstudentCourseResult.success)
          setGetAllStudentCourses(getAllstudentCourseResult.data);

        if (courseCategoriesResult.success) {
          const dynamicCategories = courseCategoriesResult.data.map(
            (cat) => cat.name
          );
          setCourseCategories(["All Courses", ...dynamicCategories]);
        } else {
          console.warn("Categories fetch unsuccessful");
        }
      } catch (error) {
        setError("Failed to fetch courses. Please try again.");
        console.error("Failed to fetch courses:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCourses();
  }, [auth.token, dispatch]);
  const allStudentCourses = useMemo(() => {
    if (activeEnrollCourse === "All Courses")
      return getAllStudentCourses.courses;
    if (activeEnrollCourse === "Favorites Courses") return favoritesCourses;
    if (activeEnrollCourse === "Enrolled Courses")
      return enrolledCourses.courses;
    if (activeEnrollCourse === "Completed Courses")
      return studentCompletedCourses.courses;
    return [];
  }, [
    activeEnrollCourse,
    enrolledCourses,
    favoritesCourses,
    activeEnrollCourse,
    getAllStudentCourses,
  ]);

  useEffect(() => {
    let filteredData = allCourses.filter(
      (item) => item?.Category?.name === activeCourse
    );
    setAllCoursesFilterByCategory(filteredData);
  }, [activeCourse]);

  return (
    <div className="student-courses-container">
      {isLoading ? (
        <div className="loader-container">
          <span className="dottedLoading theme-color"></span>
        </div>
      ) : (
        <>
          {/* Topbar */}
          <div className="topbar mb-20 mb-lg-36">
            <div className="d-flex align-items-center justify-content-between">
              <h3 className="ad-heading-04 fw-bold mb-8">All Courses</h3>
              <div className="search-wrapper d-none d-lg-flex align-items-center gap-3">
                <DashboardTopSearch />
                <Notification />
              </div>
            </div>
          </div>

          {/* Enrolled & Favorites */}
          <div className="card-default-style py-10 py-sm-20 py-md-25 px-10 px-sm-20 px-md-30 px-lg-40 mb-10 mb-sm-20 mb-md-30 mb-lg-44">
            <h1 className="fw-bold ah-heading-03 mb-lg-32 text-center">
              My Courses
            </h1>
            <div className="row">
              <div className="col-12 text-center">
                <TabFilterCourse
                  categories={ENROLL_COURSE_CATEGORIES}
                  activeCourse={activeEnrollCourse}
                  setActiveCourse={setActiveEnrollCourse}
                />
              </div>
              <div className="col-12 mb-24">
                {error ? (
                  <p className="text-danger">{error}</p>
                ) : (
                  <div className="row course-item-list">
                    <StudentEnrolledCourse
                      datafetch={UpdateDatafetch}
                      activeEnrollCourse={activeEnrollCourse}
                      courseDataList={
                        // activeEnrollCourse === "Enrolled Courses"
                        //   ? enrolledCourses.courses
                        //   : favoritesCourses
                        allStudentCourses
                      }
                    />
                  </div>
                )}
              </div>
              {/* <div className="col-12 text-center">
                <Link
                  to=""
                  className="theme-color ah-text-lg fw-semibold text-decoration-underline"
                >
                  View All
                </Link>
              </div> */}
            </div>
          </div>

          {/* All Courses */}
          <div className="card-default-style px-10 px-sm-20 px-md-25">
            <div className="row justify-content-center">
              <div className="col-12 col-md-10 col-lg-8 col-xl-6 text-center">
                <h1 className="fw-bold ah-heading-03 mb-12">
                  Explore All Courses!
                </h1>
                <p className="fw-semibold mb-lg-32 text-gray-01">
                  Dive into our extensive and diverse range of courses,
                  meticulously designed to inspire and empower you to learn
                  something new and exciting every single day!
                </p>
              </div>
            </div>

            <div className="row">
              <div className="col-12 text-center">
                <TabFilterCourse
                  categories={courseCategories}
                  activeCourse={activeCourse}
                  setActiveCourse={setActiveCourse}
                />
              </div>
              <div className="col-12">
                {error ? (
                  <p className="text-danger">{error}</p>
                ) : (
                  <div className="row course-item-list">
                    <StudentAllCourse
                      activeCourse={activeCourse}
                      datafetch={UpdateDatafetch}
                      courseDataList={
                        activeCourse === "All Courses"
                          ? allCourses
                          : allCoursesFilterByCategory
                      }
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default StudentCourses;
